<div
  class="flex h-full w-full flex-col"
  [ngClass]="{
    'cursor-not-allowed': disabled(),
    'cursor-pointer': !disabled() && !readonly(),
  }">
  <div id="input-container" class="flex h-full items-center gap-2">
    <button
      (click)="toggle()"
      class="w-fit border-none bg-inherit p-0 outline-none focus:ring-0"
      [ngClass]="{ 'pointer-events-none cursor-not-allowed': disabled() || readonly() }">
      <div
        [ngClass]="
          disabled()
            ? 'bg-gray-500'
            : checked()
              ? 'bg-[#006436] after:-translate-x-full after:translate-x-full'
              : 'bg-gray-200'
        "
        class="relative h-6 w-11 rounded-full after:absolute after:start-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-['']"></div>
    </button>
    @if (label()) {
      @if (!labelTemplate()) {
        <span>{{ label() }}</span>
      } @else {
        <ng-container
          [ngTemplateOutlet]="labelTemplate()"
          [ngTemplateOutletContext]="{ $implicit: label() }" />
      }
    }
  </div>
  @if (invalid()) {
    @for (error of errors(); track error) {
      <span class="text-error">{{ error.message }}</span>
    }
  }
</div>
